module.exports = __webpack_public_path__ + "img/26.6.CODm.cee43b88.png";